import { render, staticRenderFns } from "./stats.vue?vue&type=template&id=547f43a6&"
import script from "./stats.vue?vue&type=script&lang=js&"
export * from "./stats.vue?vue&type=script&lang=js&"
import style0 from "./stats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports